import styled from 'styled-components'

const WrapSpan = styled.span`
  position: relative;
`

export { WrapSpan }
